import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ObjectNewPageComponent} from './object-new-page/object-new-page.component';
import {SharedModule} from '../shared/shared.module';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {FormsModule} from '@angular/forms';
import {ObjectNewObjectViewComponent} from './object-new-object-view/object-new-object-view.component';
import {ObjectNewCopyViewComponent} from './object-new-copy-view/object-new-copy-view.component';
import {MediaSelectorModule} from '../media-selector/media-selector.module';
import {ObjectSearchModule} from '../object-search/object-search.module';
import {OperationsModule} from '../operations/operations.module';
import {ObjectEditModule} from '../object-edit/object-edit.module';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';



@NgModule({
  declarations: [
    ObjectNewPageComponent,
    ObjectNewObjectViewComponent,
    ObjectNewCopyViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatFormFieldModule,
    FormsModule,
    MediaSelectorModule,
    ObjectSearchModule,
    OperationsModule,
    ObjectEditModule,
    MatButtonModule,
    MatInputModule
  ]
})
export class CreateObjectModule { }
